<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="text-center my-2">{{msg}}</div>
</div>
<div class="modal-footer text-center">
  <button type="button" class="btn btn-outline-dark px-4" (click)="modal.close('Save click')">Ok</button>
</div>
